import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import WorkerDashboard from "@/pages/WorkerDashboard";
import ContractorDashboard from "@/pages/ContractorDashboard";
import ActivatePage from "@/pages/ActivatePage";
import PrivacyPage from "@/pages/PrivacyPage";
import ConfirmAssignmentPage from "@/pages/ConfirmAssignmentPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5]">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.user_type)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const RoleBasedRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5]">
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  switch (user.user_type) {
    case "admin":
      return <Navigate to="/admin" replace />;
    case "worker":
      return <Navigate to="/worker" replace />;
    case "contractor":
      return <Navigate to="/contractor" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/activate" element={<ActivatePage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/confirm-assignment" element={<ConfirmAssignmentPage />} />
          <Route path="/" element={<RoleBasedRedirect />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker/*"
            element={
              <ProtectedRoute allowedRoles={["worker", "admin"]}>
                <WorkerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contractor/*"
            element={
              <ProtectedRoute allowedRoles={["contractor"]}>
                <ContractorDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
